var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 379.88 265.89",
    style: {
      enableBackground: "new 0 0 379.88 265.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#263569;}\n\t.st2{fill:#2890C4;}\n\t.st3{fill:#20274E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334.33,30.66H45.55c-6.09,0-11.03,4.94-11.03,11.03v182.53c0,6.09,4.94,11.03,11.03,11.03h288.78 c6.09,0,11.03-4.94,11.03-11.03V41.68C345.36,35.59,340.42,30.66,334.33,30.66z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.14,67.07c-7.18-8.19-20.17-11.7-36.78-11.7h-48.22c-3.4,0-6.29,2.47-6.82,5.82l-20.08,127.33 c-0.4,2.51,1.54,4.79,4.09,4.79h29.77l7.48-47.42l-0.23,1.48c0.53-3.35,3.4-5.82,6.79-5.82h14.14c27.79,0,49.55-11.29,55.9-43.94 c0.19-0.97,0.35-1.91,0.49-2.82c-0.8-0.42-0.8-0.42,0,0C244.58,82.72,242.67,74.51,236.14,67.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.97,90.44c0.79-0.38,1.68-0.59,2.6-0.59h37.8c4.48,0,8.65,0.29,12.47,0.91c1.09,0.18,2.15,0.38,3.18,0.61 c1.03,0.23,2.03,0.48,3,0.77c0.48,0.14,0.96,0.29,1.43,0.44c1.88,0.63,3.62,1.36,5.23,2.21c1.89-12.07-0.01-20.28-6.54-27.72 c-7.19-8.19-20.17-11.7-36.78-11.7h-48.22c-3.39,0-6.28,2.47-6.81,5.82l-20.08,127.32c-0.4,2.51,1.54,4.79,4.09,4.79h29.77 l15.51-98.35C173.93,92.93,175.23,91.28,176.97,90.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.19,97.61c-6.36,32.65-28.11,43.94-55.9,43.94h-14.15c-3.39,0-6.26,2.47-6.79,5.82l-9.3,58.96 c-0.35,2.2,1.35,4.19,3.57,4.19h25.09c2.97,0,5.5-2.16,5.96-5.09l0.24-1.28l4.73-29.97l0.3-1.66c0.46-2.93,2.99-5.09,5.96-5.09 h3.76c24.31,0,43.34-9.87,48.9-38.43c2.32-11.93,1.12-21.9-5.02-28.9c-1.86-2.12-4.18-3.87-6.87-5.3 C242.54,95.71,242.38,96.65,242.19,97.61L242.19,97.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.03,92.14c-0.97-0.28-1.97-0.54-3-0.77s-2.09-0.43-3.18-0.61c-3.82-0.62-7.99-0.91-12.47-0.91h-37.8 c-0.93,0-1.82,0.21-2.6,0.59c-1.75,0.84-3.04,2.48-3.36,4.51l-8.03,50.94l-0.23,1.48c0.53-3.35,3.39-5.82,6.79-5.82h14.15 c27.79,0,49.55-11.29,55.9-43.94c0.19-0.97,0.35-1.9,0.49-2.82c-1.61-0.85-3.35-1.58-5.23-2.21 C236.99,92.43,236.52,92.28,236.03,92.14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.a02107d02460da3215c4c7479db5cb6c.svg";
export { ForwardRef as ReactComponent };